/**
 * PrazoModal - Modal para adicionar/editar prazos
 */
import { useState, useEffect } from 'react'
import Modal from '@components/shared/Modal'
import { useNotification } from '@context/NotificationContext'
import AuthService from '@services/auth'

export default function PrazoModal({ isOpen, onClose, prazo, onSave }) {
  const notify = useNotification()
  const [formData, setFormData] = useState({
    titulo: '',
    processo: '',
    data: '',
    area: '',
    descricao: '',
  })
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (prazo) {
      setFormData({
        titulo: prazo.titulo || prazo.numeroProcesso || '',
        processo: prazo.processo || prazo.numeroProcesso || '',
        data: prazo.data ? prazo.data.split('T')[0] : '',
        area: prazo.area || '',
        descricao: prazo.descricao || '',
      })
    } else {
      setFormData({ titulo: '', processo: '', data: '', area: '', descricao: '' })
    }
  }, [prazo, isOpen])

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!formData.titulo || !formData.data || !formData.area) {
      notify.showWarning('Preencha todos os campos obrigatórios')
      return
    }
    setSaving(true)
    try {
      await onSave(
        {
          ...formData,
          numeroProcesso: formData.processo,
          status: 'verde',
          responsavel: AuthService.getCurrentUser()?.nome || 'sistema',
          criadoPor: AuthService.getCurrentUser()?.nome || 'sistema',
        },
        prazo?.id
      )
      notify.showSuccess(prazo ? 'Prazo atualizado!' : 'Prazo criado!')
      onClose()
    } catch {
      notify.showError('Erro ao salvar prazo')
    } finally {
      setSaving(false)
    }
  }

  const areas = [
    { value: '', label: 'Selecione uma área' },
    { value: 'civel', label: 'Cível' },
    { value: 'trabalhista', label: 'Trabalhista' },
    { value: 'criminal', label: 'Criminal' },
    { value: 'familia', label: 'Família' },
    { value: 'tributario', label: 'Tributário' },
    { value: 'administrativo', label: 'Administrativo' },
    { value: 'consumidor', label: 'Consumidor' },
    { value: 'outros', label: 'Outros' },
  ]

  const footer = (
    <>
      <button className="btn-modern btn-modern-cancel" onClick={onClose}>
        <i className="fas fa-times" /> Cancelar
      </button>
      <button className="btn-modern btn-modern-save" onClick={handleSubmit} disabled={saving}>
        {saving ? (
          <>
            <i className="fas fa-spinner fa-spin" /> Salvando...
          </>
        ) : (
          <>
            <i className="fas fa-save" /> Salvar Prazo
          </>
        )}
      </button>
    </>
  )

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={prazo ? 'Editar Prazo' : 'Adicionar Novo Prazo'}
      subtitle={prazo ? 'Atualize os dados do prazo' : 'Preencha os campos abaixo para cadastrar o prazo'}
      icon="fa-calendar-plus"
      size="lg"
      footer={footer}
    >
      <form onSubmit={handleSubmit}>
        <div className="modern-form-grid">
          {/* Título */}
          <div className="modern-form-group">
            <label>
              <i className="fas fa-heading" /> Título <span className="required">*</span>
            </label>
            <input
              type="text"
              required
              placeholder="Ex: Contestação - Processo 1234"
              value={formData.titulo}
              onChange={(e) => handleChange('titulo', e.target.value)}
            />
          </div>

          {/* Processo */}
          <div className="modern-form-group">
            <label>
              <i className="fas fa-gavel" /> Número do Processo
            </label>
            <input
              type="text"
              placeholder="0000000-00.0000.0.00.0000"
              value={formData.processo}
              onChange={(e) => handleChange('processo', e.target.value)}
            />
          </div>

          {/* Data */}
          <div className="modern-form-group">
            <label>
              <i className="fas fa-calendar-alt" /> Data do Prazo <span className="required">*</span>
            </label>
            <input
              type="date"
              required
              value={formData.data}
              onChange={(e) => handleChange('data', e.target.value)}
            />
          </div>

          {/* Área */}
          <div className="modern-form-group">
            <label>
              <i className="fas fa-balance-scale" /> Área <span className="required">*</span>
            </label>
            <select required value={formData.area} onChange={(e) => handleChange('area', e.target.value)}>
              {areas.map((a) => (
                <option key={a.value} value={a.value}>
                  {a.label}
                </option>
              ))}
            </select>
          </div>

          {/* Descrição */}
          <div className="modern-form-group full-width">
            <label>
              <i className="fas fa-align-left" /> Descrição
            </label>
            <textarea
              rows={3}
              placeholder="Detalhes adicionais sobre o prazo..."
              value={formData.descricao}
              onChange={(e) => handleChange('descricao', e.target.value)}
            />
          </div>
        </div>
      </form>
    </Modal>
  )
}
